import React from 'react';
import {CoachLogo, CoachLogoColor} from '@components/logo/CoachLogo';
import './LoginBranding.styl';

interface LoginBrandingProps {}

export const LoginBranding: React.FC<LoginBrandingProps> = () => {
  return (
    <div className="login-branding">
      <Coach360Branding />
    </div>
  );
};

function Coach360Branding() {
  return (
    <div className="coach360-branding">
      <CoachLogo color={CoachLogoColor.LIGHT} />
      <div className="content-wrapper">
        <div className="middle-blurb">
          <h1>Conversation Intelligence, Sales Coaching & Training</h1>
          <p>
            Login now and get your sales reps sales-ready with the confidence, capabilities, and
            credibility they need to have more valuable conversations. Coach helps reps master
            skills and drive long-term behavior change by focusing coaching energy where it will
            have the most impact.
          </p>
        </div>
      </div>
    </div>
  );
}
